/**
 * UI Store
 * Manages mobile drawer and sidebar state for admin panel
 */

import { create } from 'zustand';

interface UIState {
  isMobileDrawerOpen: boolean;
  isSidebarCollapsed: boolean;

  openMobileDrawer: () => void;
  closeMobileDrawer: () => void;
  toggleMobileDrawer: () => void;

  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  isMobileDrawerOpen: false,
  isSidebarCollapsed: false,

  openMobileDrawer: () => set({ isMobileDrawerOpen: true }),
  closeMobileDrawer: () => set({ isMobileDrawerOpen: false }),
  toggleMobileDrawer: () => set((state) => ({ isMobileDrawerOpen: !state.isMobileDrawerOpen })),

  toggleSidebar: () => set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
  setSidebarCollapsed: (collapsed: boolean) => set({ isSidebarCollapsed: collapsed }),
}));

export const useMobileDrawer = () => {
  const isMobileDrawerOpen = useUIStore((state) => state.isMobileDrawerOpen);
  const openMobileDrawer = useUIStore((state) => state.openMobileDrawer);
  const closeMobileDrawer = useUIStore((state) => state.closeMobileDrawer);
  const toggleMobileDrawer = useUIStore((state) => state.toggleMobileDrawer);

  return {
    isMobileDrawerOpen,
    openMobileDrawer,
    closeMobileDrawer,
    toggleMobileDrawer,
  };
};

export const useSidebar = () => {
  const isSidebarCollapsed = useUIStore((state) => state.isSidebarCollapsed);
  const toggleSidebar = useUIStore((state) => state.toggleSidebar);
  const setSidebarCollapsed = useUIStore((state) => state.setSidebarCollapsed);

  return {
    isSidebarCollapsed,
    toggleSidebar,
    setSidebarCollapsed,
  };
};
